import * as React from 'react'
import { MediaElementProps } from './types'
import { PlayButton, VideOverlay, VideoContainer } from './styled'

export const MediaElement: React.FC<MediaElementProps> = ({ mediaSrc, alt, title, imageFromFrameAt, className }) => {
  // render video or image based on the mediaSrc provided
  // get the mediaSrc and based on the file extension render the video or image element with the correct attributes and classes

  const isVideo = mediaSrc.includes('.mp4') || mediaSrc.includes('.webm') || mediaSrc.includes('.ogg') || mediaSrc.includes('.mov') || mediaSrc.includes('.av1')
  const isImage = mediaSrc.includes('.jpg') || mediaSrc.includes('.jpeg') || mediaSrc.includes('.png') || mediaSrc.includes('.gif') || mediaSrc.includes('.svg')

  const videoRef = React.useRef<HTMLVideoElement>(null);

  const [started, setStarted] = React.useState(false)

  const handlePlay = () => {
    const video = videoRef.current;
    if (video && !started) {
      video.currentTime = 0;
      setStarted(true)
    }
    video.play();
  };

  if (isVideo) {
    return (
      <VideoContainer>
        <video ref={videoRef}
          className={className} autoPlay={false} loop={false} preload='auto' muted={false} playsInline={false}
          controls={started}
          width='100%'

          onPlay={handlePlay}
        >
          <source
            src={mediaSrc + `#t=${imageFromFrameAt}`}
            type={`video/${mediaSrc.split('.').pop()}`} />
          Your browser does not support the video tag.
        </video >
        {!started &&
          <VideOverlay
            onClick={handlePlay}
          >
            <PlayButton  >
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                <path d="M32.0036 13.6694C35.3373 15.5941 35.3373 20.4059 32.0036 22.3306L9.5009 35.3226C6.16717 37.2473 2 34.8414 2 30.9919L2 5.00807C2 1.1586 6.16717 -1.24732 9.5009 0.677413L32.0036 13.6694Z" fill="white" />
              </svg>
            </PlayButton>
          </VideOverlay >
        }
      </VideoContainer>

    )
  }

  if (!isImage) {
    return null
  }

  return <img className={className} src={mediaSrc} alt={alt || title} />

}
